var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_5274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 20.7917C22.9166 21.3442 22.6972 21.8741 22.3065 22.2648C21.9158 22.6555 21.3858 22.875 20.8333 22.875L4.16665 22.875C3.61411 22.875 3.08421 22.6555 2.69351 22.2648C2.30281 21.8741 2.08331 21.3442 2.08331 20.7917L2.08331 6.20833C2.08331 5.6558 2.30281 5.12589 2.69351 4.73519C3.08421 4.34449 3.61411 4.125 4.16665 4.125L9.37498 4.125L11.4583 7.25L20.8333 7.25C21.3858 7.25 21.9158 7.46949 22.3065 7.86019C22.6972 8.25089 22.9166 8.7808 22.9166 9.33333L22.9166 20.7917Z",
    fill: "#1D7777",
    stroke: "#1D7777",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_5274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(25.5 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIc);
export default __webpack_public_path__ + "static/media/folder_ic.960a5dd45cfdfba8f96802c8cb0fbd48.svg";
export { ForwardRef as ReactComponent };